import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class UnsupportedMessageRecord
 * @augments BaseMessageRecord
 */
class UnsupportedMessageRecord extends BaseMessageRecord({
  type: "unsupported",

  /** @memberof UnsupportedMessageRecord# */
  originalBlockType: "unknown",

  /** @memberof UnsupportedMessageRecord# */
  originalMessage: Immutable.Map()
}) {
  /**
   * Validation
   */

  /**
   * @returns {Immutable.List.<String>}
   */
  static getInvalidFields = () => Immutable.List();
  /**
   * Custom JSON serialization so that we get the original message
   * when we're copying / pasting
   */
  toJSON() {
    return this.originalMessage.toJSON();
  }
}

export default UnsupportedMessageRecord;
